import { useState, useEffect } from "react";
import "../App.css";
import "../css/Nav design.css";
import axios from "axios";
import ApiConfig from "../utils/ApiConfig";
import ApiResponse from "../model/response/ApiResponse";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import logo from "../images/logo.jpeg";

function Payment() {
    const navigation = useNavigate();
    const location = useLocation();

    // SAFE LOCAL STORAGE PARSE
    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    const token = localStorage.getItem('token');


    const [isLoading, setIsLoading] = useState(false);
    const [amount, setAmount] = useState(location.state?.amount ? location.state.amount.toString() : "");

    useEffect(() => {
        if (location.state?.amount) {
            setAmount(location.state.amount.toString());
        }
    }, [location.state]);

    // LOAD RAZORPAY SDK
    useEffect(() => {
        const loadScript = () => {
            return new Promise((resolve) => {
                if (window.Razorpay) {
                    resolve(true);
                    return;
                }

                const script = document.createElement("script");
                script.src = "https://checkout.razorpay.com/v1/checkout.js";
                script.async = true;

                script.onload = () => resolve(true);
                script.onerror = () => resolve(false);

                document.body.appendChild(script);
            });
        };

        loadScript();
    }, []);

    const handlePayment = async () => {
        // VALIDATION
        if (!loginVal) {
            toast.error("Please login to proceed with payment");
            return;
        }

        if (!amount || Number(amount) <= 0) {
            toast.error("Please enter valid amount");
            return;
        }

        if (!window.Razorpay) {
            toast.error("Razorpay SDK not loaded");
            return;
        }

        if (isLoading) return;

        setIsLoading(true);

        try {
            // CREATE ORDER API
            const orderResponse = await axios.post(
                ApiConfig.getUrl("api/Razorpay/create-order"),
                {
                    user_Id: loginVal.user_Id,
                    amount: Number(amount), // send numeric amount
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // Assuming the API returns the Razorpay order details directly as per the provided sample
            const api = ApiResponse.fromJson(orderResponse.data);

            if (api.statusCode !== 200 || !api.response?.id) {
                toast.error(api.errorMessage || "Failed to create order");
                setIsLoading(false);
                return;
            }
            const orderDetails = api.response;

            // RAZORPAY OPTIONS
            const options = {
                key: "rzp_test_dlSr3kEbpxikdJ",

                amount: orderDetails.amount,

                currency: orderDetails.currency || "INR",

                name: "IndiaMetti",

                description: "Premium Membership",

                order_id: orderDetails.id,

                prefill: {
                    name: loginVal.user_Name || "",
                    email: loginVal.email_Id || "",
                    contact: loginVal.mobile_number || "",
                },

                notes: {
                    userId: loginVal.user_Id,
                },

                theme: {
                    color: "#ff8c00",
                },

                handler: async function (response) {
                    console.log("Payment Success:", response);

                    try { // Keep the try-catch for the handler function
                        // Call PaymentIntimation API and use its response for verification
                        // Assuming payment-intimation API returns a status similar to payment-success
                        const intimationResponse = await axios.get(
                            ApiConfig.getUrl("api/Razorpay/PaymentIntimation"),
                            {
                                params: { // Changed to params for GET request
                                    userId: loginVal.user_Id,
                                    paymentId: response.razorpay_payment_id,
                                    RazorpayOrderId: orderDetails.id, // Corrected to match backend expected key
                                },
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${token}`,
                                },
                            }
                        );
                        console.log("Payment Intimation API called successfully.");

                        const intimationData = ApiResponse.fromJson(intimationResponse.data);

                        if (intimationData.statusCode === 200) {
                            toast.success(intimationData.response.intimationMessageEnglish || "Payment Successful!");

                            // Update paid status in local storage
                            const updatedLoginVal = { ...loginVal, isPaid: true };
                            localStorage.setItem('loginVal', JSON.stringify(updatedLoginVal));
                            loginVal = updatedLoginVal;

                            setTimeout(() => {
                                navigation("/Viewpage");
                            }, 1500);
                        } else {
                            toast.error(
                                intimationData.errorMessage ||
                                "Payment intimation failed"
                            );
                        }
                    } catch (error) {
                        console.error(
                            "Verification Error:",
                            error
                        );

                        if (error.response) {
                            toast.error(
                                error.response.data.errorMessage ||
                                "Payment intimation failed"
                            );
                        } else {
                            toast.error(
                                "Verification failed"
                            );
                        }
                    } finally {
                        setIsLoading(false);
                    }
                },

                

                modal: {
                    ondismiss: function () {
                        console.log("Payment popup closed");
                        toast.info("Payment cancelled");
                        setIsLoading(false);
                    },
                },
            };

            const paymentObject = new window.Razorpay(options);

            // PAYMENT FAILED
            paymentObject.on(
                "payment.failed",
                function (response) {
                    console.log(
                        "Payment Failed:",
                        response
                    );

                    toast.error(
                        response.error.description ||
                        "Payment Failed"
                    );

                    setIsLoading(false);
                }
            );

            paymentObject.open();
        } catch (error) {
            console.error("Create Order Error:", error);

            if (error.response) {
                toast.error(
                    error.response.data.errorMessage ||
                    "Unable to create order"
                );
            } else {
                toast.error("Unable to process payment");
            }

            setIsLoading(false);
        }
    };

    

    return (
        <div className="fullview">
            <ToastContainer />

            {/* LOADER */}
            {isLoading && (
                <div className="loader-overlay">
                    <Oval
                        height={60}
                        width={60}
                        color="#ffffff"
                        secondaryColor="#cccccc"
                        strokeWidth={4}
                        visible={true}
                    />
                </div>
            )}

            {/* CARD */}
            <div
                className="card"
                style={{
                    marginTop: "100px",
                    maxWidth: "500px",
                    marginInline: "auto",
                    borderRadius: "15px",
                    boxShadow:
                        "0 4px 15px rgba(0,0,0,0.1)",
                }}
            >
                <div className="p-4 text-center">
                    <img
                        src={logo}
                        alt="logo"
                        style={{
                            width: "80px",
                            height: "80px",

                        }}
                    />

                    <h3 className="mt-3">
                        Payment Details
                    </h3>

                    {/* AMOUNT INPUT */}
                    <input
                        type="text"
                        placeholder="Enter amount"
                        value={amount}

                        className="form-control mt-3"
                        onChange={(e) =>
                            setAmount(e.target.value)
                        }
                    />

                    {/* PAY BUTTON */}
                    <button
                        type="button"
                        className="btn btn-success px-4 mt-3"
                        // onClick={handlePayment}
                        disabled={isLoading}
                        style={{
                            backgroundColor: "darkorange",
                            border: "none",
                            borderRadius: "8px",
                        }}
                    >
                        {isLoading
                            ? "Processing..."
                            : "Pay Now"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Payment;